export const fonts = {
  heading: `"Fraunces", Georgia, "Times New Roman", serif`,
  body: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`,
};

export const easing = {
  out: "cubic-bezier(0.22, 1, 0.36, 1)",
  inOut: "cubic-bezier(0.65, 0, 0.35, 1)",
};

export const shadows = {
  sm: "0 1px 2px rgba(28, 28, 28, 0.06), 0 4px 12px rgba(28, 28, 28, 0.04)",
  md: "0 12px 32px rgba(28, 28, 28, 0.08)",
  lg: "0 24px 60px rgba(28, 28, 28, 0.16)",
  honey: "0 10px 28px rgba(255, 140, 0, 0.3)",
};

export const radii = {
  sm: "0.5rem",
  md: "1rem",
  lg: "1.5rem",
  pill: "999px",
};

export const layout = {
  maxWidth: "1200px",
  gutter: "clamp(1.25rem, 4vw, 2.5rem)",
  navHeight: "5rem",
  navHeightCompact: "4rem",
};

export const media = {
  mobile: "@media screen and (max-width: 768px)",
  tablet: "@media screen and (max-width: 960px)",
  // Touch screens keep :hover applied after a tap, so lift/zoom effects are
  // limited to devices with a real pointer.
  hoverable: "@media (hover: hover)",
};
